// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e4cccf77","404":"2d791a60","718":"54c2a018","787":"accd547f"}[chunkId] + ".chunk.js";
};